import {defineStore} from 'pinia'
import {SESSION_AWARE_ROLES} from "~/utils/roles"
import type {OutputSession} from "~/models"

export const useSessionsStore = defineStore('sessions', {
    state: () => ({
        sessions: [] as OutputSession[],
    }),
    actions: {
        async load() {
            const {user} = useAuth()

            // Єдиний гейт на всі виклики: ролі поза списком не мають доступу до
            // GET /api/sessions, і смикати його — це гарантована 403 у консолі.
            if (!SESSION_AWARE_ROLES.includes(user.value?.role as string)) {
                return
            }

            this.sessions = await useApi().getSessions()
        },
    },
})